export const merchantDelegationActions = {

};